// extracted by mini-css-extract-plugin
module.exports = {"root":"template-employee-source_root__3VwRH"};